import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconDashboard } from "@tabler/icons-react";
import { DashboardSupervisoresDef } from "./DashboardSupervisoresDef";

export const DashboardSupervisoresIcon = IconDashboard;
export const DashboardSupervisoresHelpText = '* Dashboard';

export class DashboardSupervisores extends Entity<DashboardSupervisoresDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DashboardSupervisoresDef(), parentKeys);
        this.Form = import('./DashboardSupervisoresForm').then((module) => module.DashboardSupervisoresForm);
        this.Title = "PowerBI Supervisores";
        this.HelpText = DashboardSupervisoresHelpText;
        this.Icon = DashboardSupervisoresIcon;
    }
}